import React from 'react'
import { ChatInterface } from '../components/chat/ChatInterface'
import { UserMenu } from '../components/UserMenu'
import { KnowledgeGapButton } from '../components/KnowledgeGapButton'
import { MainNavigation } from '../components/MainNavigation'
import { motion } from 'framer-motion'

export function ChatPage() {

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="glass border-b border-white/10 px-4 py-3">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <h1 className="text-xl font-bold gradient-text">XORA</h1>
            <MainNavigation className="hidden md:flex" />
          </div>
          
          <div className="flex items-center space-x-4">
            <KnowledgeGapButton />
            <UserMenu />
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center p-4">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3 }}
          className="w-full max-w-4xl h-full"
        >
          <ChatInterface />
        </motion.div>
      </main>

      {/* Version info - desktop */}
      <div className="hidden md:block fixed bottom-4 left-4 text-xs text-gray-600">
        v2.0.1
      </div>
    </div>
  )
}